
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PlansModalBridgeService {

  private readonly _open$ = new Subject<{ reason?: string; status?: number }>();

  readonly open$ = this._open$.asObservable();

  requestOpen(payload: { reason?: string; status?: number } = {}): void {
    this._open$.next(payload);
  }

}
